/** Ayuda — formulario Evaluación Inicial de Terapia Ocupacional */

export const SECCIONES_AYUDA_FORM_EVAL_INICIAL = [
  {
    titulo: "¿Qué es este formulario?",
    parrafos: [
      "Documento clínico de Evaluación Inicial de Terapia Ocupacional. Complete las secciones, guarde y podrá imprimir el PDF con su firma digital.",
    ],
  },
  {
    titulo: "Campo Fecha (muy importante)",
    parrafos: [
      "Al crear un informe nuevo, el campo Fecha suele aparecer con la fecha del día en que usted abre el formulario.",
      "En la práctica, esa fecha debería corresponder a la evaluación inicial real del paciente, que muchas veces coincide con la fecha de su primera terapia.",
      "Puede cambiar la Fecha manualmente en cualquier momento antes de guardar. Esto es especialmente útil en terapias antiguas que aún no tenían evaluación inicial registrada: coloque la fecha en que el paciente inició o en que usted realizó la evaluación, no necesariamente el día de hoy.",
      "El campo Inicio terapia se carga automáticamente desde el estudio del paciente en el sistema. Revise que ambas fechas sean coherentes con el historial del caso.",
    ],
  },
  {
    titulo: "Datos generales",
    lista: [
      "Nombre, cédula, sexo, edad y datos de nacimiento se cargan desde la planilla del paciente.",
      "Diagnóstico, referencia, colegio, grado escolar y datos de los padres puede completarlos o corregirlos según su evaluación.",
      "Inicio terapia: fecha de inicio del estudio activo en el sistema.",
    ],
  },
  {
    titulo: "Secciones clínicas",
    lista: [
      "Antecedentes: desarrollo prenatal, natal y postnatal.",
      "Actividades de la vida diaria (AVD e instrumentales).",
      "Conducta, Cognición, Motricidad fina y Motricidad gruesa.",
      "Cierre: observaciones finales y conclusiones de la evaluación.",
    ],
  },
  {
    titulo: "Firma del especialista",
    parrafos: [
      "Al final del formulario debe tener cargada su firma digital. Sin firma no podrá imprimir el PDF del informe.",
    ],
  },
  {
    titulo: "Botones",
    lista: [
      "Guardar: almacena el informe en el sistema.",
      "Imprimir PDF: genera el documento (requiere firma).",
      "Eliminar informe: solo visible si ya guardó y está editando.",
      "Volver: regresa a la pantalla anterior sin cerrar el módulo.",
    ],
  },
  {
    titulo: "Recomendación para casos retrospectivos",
    parrafos: [
      "Si el paciente lleva meses o años en terapia y recién crea la evaluación inicial, ajuste la Fecha del informe a la fecha real de la evaluación o al inicio del tratamiento. Así los informes posteriores (Plan y avances) mantendrán coherencia con el conteo de citas pagadas.",
    ],
  },
];
